import { render, staticRenderFns } from "./NgTextScan.vue?vue&type=template&id=0a482f5b"
import script from "./NgTextScan.vue?vue&type=script&lang=js"
export * from "./NgTextScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports